import React from 'react';
import { Shield, Award } from 'lucide-react';
import { motion } from 'framer-motion';

export const PartenairesSection = () => {
  return (
    <section className="py-16 relative overflow-hidden bg-[#0A0A0A]">
      {/* Background Effects */}
      <div className="absolute inset-0 network-lines opacity-5"></div>
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#FF6B35] mb-4 block">
            Partenaires Certifiés
          </span>
          <h2 className="text-3xl sm:text-4xl font-black mb-4 tracking-tight">
            <span className="text-[#FF6B35]">Distributeur Officiel</span> Ubiquiti
          </h2>
          <p className="text-gray-400 max-w-3xl mx-auto">
            Innova-Solution est fière d'être distributeur officiel et installateur autorisé Ubiquiti. 
            Profitez de solutions réseau entreprise de classe mondiale avec notre expertise certifiée.
          </p>
        </motion.div>

        {/* Certifications */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="glass rounded-2xl p-8 border border-[#FF6B35]/20 hover:border-[#FF6B35]/50 transition-all duration-300 group"
          >
            <div className="flex items-center gap-4 mb-4">
              <div className="w-12 h-12 bg-[#FF6B35]/10 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform">
                <Shield className="w-6 h-6 text-[#FF6B35]" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-white">Distributeur Officiel</h3>
                <p className="text-sm text-gray-400">Produits authentiques garantis</p>
              </div>
            </div>
            <p className="text-gray-300 text-sm">
              Accédez à l'ensemble du catalogue Ubiquiti avec la garantie d'authenticité et le support officiel du fabricant.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="glass rounded-2xl p-8 border border-[#FF6B35]/20 hover:border-[#FF6B35]/50 transition-all duration-300 group"
          >
            <div className="flex items-center gap-4 mb-4">
              <div className="w-12 h-12 bg-[#FF6B35]/10 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform">
                <Award className="w-6 h-6 text-[#FF6B35]" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-white">Installateur Autorisé</h3>
                <p className="text-sm text-gray-400">Expertise certifiée</p>
              </div>
            </div>
            <p className="text-gray-300 text-sm">
              Notre équipe certifiée assure l'installation, la configuration et le support de vos solutions Ubiquiti selon les standards du fabricant.
            </p>
          </motion.div>
        </div>

        {/* Logos */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="flex items-center justify-center gap-12 flex-wrap"
        >
          <div className="flex items-center gap-2">
            <img 
              src="/images/partners/ubiquiti-horizontal-light.png" 
              alt="Ubiquiti" 
              className="h-12 w-auto opacity-80 hover:opacity-100 transition-opacity"
            />
          </div>
          <div className="w-px h-12 bg-white/20"></div>
          <div className="flex items-center gap-2">
            <img 
              src="/images/partners/unifi-light.png" 
              alt="UniFi" 
              className="h-12 w-auto opacity-80 hover:opacity-100 transition-opacity"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};
